<template>
  <button
    v-if="isImpersonating"
    data-testid="impersonation-indicator"
    class="flex items-center gap-2 px-3 py-2 text-sm font-semibold rounded-md transition-colors bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/50 focus-visible:ring focus-visible:ring-amber-500/50 focus:outline-none"
    :title="`You are currently impersonating: ${userStore.email}`"
    @click="handleStopImpersonating"
  >
    <Icon name="general.impersonating" size="base" />
    <span class="hidden sm:inline">Impersonating</span>
  </button>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook';
import { useUserStore } from '@/store/useUserStore';
import { useAdminActions } from '@/composables/useAdminActions';

const userStore = useUserStore();
const { isImpersonating } = storeToRefs(userStore);
const { stopImpersonating } = useAdminActions();

const handleStopImpersonating = async () => {
  const confirmed = window.confirm(`You are currently impersonating: ${userStore.email}\n\nAre you sure you want to stop impersonating?`);

  if (confirmed) {
    await stopImpersonating();
  }
};
</script>
